"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgentAvatar = AgentAvatar;
exports.UserAvatar = UserAvatar;
var _react = _interopRequireDefault(require("react"));
var _optum = _interopRequireDefault(require("./assets/optum.png"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function UserAvatar(_ref) {
  let {
    userName
  } = _ref;
  const initials = userName ? userName.split(' ').filter(Boolean).map(p => p[0]).join('').toUpperCase().slice(0, 2) : 'U';
  return (0, _jsxRuntime.jsx)("span", {
    className: "tw-flex-shrink-0 tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full tw-bg-sa-primary tw-text-white tw-text-xs tw-font-semibold tw-select-none",
    title: userName || 'You',
    children: initials
  });
}
function AgentAvatar(_ref2) {
  let {
    state = 'idle'
  } = _ref2;
  const stateClasses = {
    idle: '',
    thinking: 'tw-animate-sa-pulse',
    error: 'tw-bg-sa-error'
  };
  return (0, _jsxRuntime.jsx)("span", {
    className: "tw-flex-shrink-0 tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full tw-overflow-hidden ".concat(stateClasses[state] || ''),
    title: "SmartAssist",
    children: (0, _jsxRuntime.jsx)("img", {
      src: _optum.default,
      alt: "SmartAssist",
      className: "tw-w-full tw-h-full tw-object-contain"
    })
  });
}